/**
 * 🔥 EscPosBase64Decoder
 * --------------------------------------------------------------
 * Esta utilidad convierte una cadena Base64 (proveniente del backend)
 * en un string de bytes ESC/POS legible por impresoras térmicas.
 *
 * Justificación técnica:
 * - Las impresoras térmicas interpretan bytes crudos (ESC/POS)
 * - El backend encapsula esos bytes en Base64 para transporte seguro
 * - atob() decodifica Base64 → bytes
 * - String.fromCharCode() reconstruye el byte stream imprimible
 *
 * Compatibilidad:
 * ✅ Web
 * ✅ QZ Tray
 * ✅ ECSPOS
 *
 * Advertencia:
 * No usar Buffer.from() en navegador (rompe encoding).
 */
export class EscPosBase64Decoder {

  /**
   * Decodifica una cadena en Base64 a un string JS
   * que contiene bytes ESC/POS (control + texto).
   *
   * @param base64 Cadena Base64 proveniente del backend
   * @returns Bytes ESC/POS reconstruidos como string JS
   *
   * Ejemplo:
   *   "G2EBG3QQ..." → "\x1B\x40Texto..."
   */
  public static decode(base64: string): string {
    const binary = atob(base64);
    let result = '';

    for (let i = 0; i < binary.length; i++) {
      result += String.fromCharCode(binary.charCodeAt(i));
    }

    return result;
  }


  static decodeToPrintableText(base64: string): string {
    try {

      // ✅ Base64 → Uint8Array
      const bytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0));

      // ✅ Decoder CP1252/Latin1
      const raw = new TextDecoder("latin1").decode(bytes);

      return raw
        .replace(/\x1B[@!a-d0-9()]{0,2}/g, "")                     // ESC commands
        .replace(/\x1D[Vv]{0,2}/g, "")                             // GS commands
        .replace(/\x1Bd(.)/g, (_, n) => "\n".repeat(n.charCodeAt(0))) // feed
        .replace(/[^\x20-\x7EáéíóúÁÉÍÓÚñÑüÜ]/g, "")                // Solo imprimibles
        .trim();

    } catch {
      return "";
    }
  }





}
